'use client';

import { Loader } from '@/components/common/loaders/loaders';
import { useAuth } from '@/lib/client/hooks/useAuth';
import { useRouter } from 'next/navigation';
import { ReactNode, useEffect, useState } from 'react';

export default function AuthTemaplate({ children }: { children: ReactNode }) {
  const { isLoggedIn, isLoading: isAuthLoading } = useAuth();
  const router = useRouter();
  const [shouldRun, setShouldRun] = useState(true);

  useEffect(() => {
    if (isAuthLoading || !shouldRun) return;

    setShouldRun(false);

    if (isLoggedIn) {
      router.replace(`/app`);
    }
  }, [isAuthLoading, isLoggedIn, router]);

  if (isAuthLoading) {
    return (
      <div className='h-screen/header-2 sm:h-screen/header flex items-center justify-center'>
        <Loader className='w-10 h-10 text-brand' />
      </div>
    );
  }

  return <>{children}</>;
}
